import styled, { css } from 'styled-components';

import {
  ThemeProps as Prop, Breakpoints, Components,
  FontFamily,
  FontSize,
} from '@powdr/constants';
import { themeUtil, rgbaTransparencyToHex, getFontStyles } from '@powdr/utils';

const CPNT = Components.MODAL;

const topSpacePx = 65;

export const ModalOverlay = styled.div`
  background-color: ${() => themeUtil(Prop.ICON, CPNT) + rgbaTransparencyToHex(0.75)};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 198;

  ${({ $isMiniModal }) => $isMiniModal && `
    display: flex;
    align-items: center;
    justify-content: center;
  `};
`;

const notDialogAlertStyles = css`
  overflow: hidden;

  ${Breakpoints.mobile(css`
    overflow: scroll;
  `)}
`;

const notFullScreen = css`
  border: 10px solid ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};
  border-radius: 10px;
  margin: 100px 100px 0 100px;
  position: relative;
  width: calc(100% - 200px);
  height: calc(100% - 200px);

  ${Breakpoints.mobile(css`
    width: calc(100% - 100px);
    height: calc(100% - 100px);
    margin: 50px;
  `)}

  ${Breakpoints.portrait(css`
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    margin: 20px;
  `)}

  ${Breakpoints.portraitSmall(css`
    border: 0;
    border-radius: 0;
    width: 100%;
    height: 100%;
    margin: 0;
  `)}
`;

const isMiniModal = css`
  height: 50%;
  width: 50%;
  position: relative;
  border: 3px solid ${({ $colorProfile }) => themeUtil(Prop.BORDER, CPNT, $colorProfile)};

  ${Breakpoints.desktopOnly(css`
    min-width: 800px;
    min-height: 600px;
  `)}

  ${Breakpoints.mobile(css`
    width: calc(100% - 30px);
    height: calc(100% - 30px);
    margin: 15px;
    top: 0;
  `)}
`;

const closeButtonShared = css`
  position: absolute;
  right: 20px;
  top: 20px;

  ${Breakpoints.mobile(css`
    right: 15px;
    top: 15px;
  `)}

  ${Breakpoints.portrait(css`
    right: 10px;
    top: 10px;
  `)}

  ${Breakpoints.portraitSmall(css`
    right: 12px;
    top: 12px;
  `)}
`;

export const ContentSpacer = styled.div`
  height: ${topSpacePx}px;

  ${({ $isMiniModal }) => ($isMiniModal) && `
    position: absolute;
    z-index: 1;
    width: 100%;
  `}
`;

export const DialogContent = styled.div`
  position: absolute;
  height: calc(100% - ${topSpacePx}px);
  margin: 0 auto;
  width: 100%;
  ${({ isDialogAlert }) => !isDialogAlert && notDialogAlertStyles}

  ${({ $isMiniModal }) => ($isMiniModal) && `
    height: 100%;
  `}
`;

export const DialogAlert = styled.div`
  background: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const DialogPage = styled.section`
  background: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};
  width: 100%;
  height: 100%;
  border-radius: 0;
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 199;
  ${({ $isFullScreen, $isMiniModal }) => (!$isFullScreen && !$isMiniModal) && notFullScreen}
  ${({ $isMiniModal }) => $isMiniModal && isMiniModal}
`;

export const CloseButton = styled.button`
  ${closeButtonShared}
  background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)};
  border-radius: 25px;
  display: block;
  padding: 15px;

  svg {
    fill: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};
  }

  &:hover {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};

    svg {
      fill: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};
      color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};
    }
  }
`;

export const CloseButtonAlt = styled.button`
  align-items: center;
  display: flex;
  ${closeButtonShared}

  .close {
    color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG50, undefined, undefined)};
    padding-right: 10px;
    text-transform: uppercase;
  }

  .button {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};

    svg {
      fill: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
      color: ${({ $colorProfile }) => themeUtil(Prop.CONTENT, CPNT, $colorProfile)};
    }
  }
`;

export const DialogHeader = styled.div``;
export const DialogBody = styled.div`
  width: 100%;
  height: 100%;
`;
export const DialogFooter = styled.div``;
